import { LitElement } from "lit";
import { customElement } from "lit/decorators.js";
import SlhBaseNavigationItem from "./item-base";

/**
 * Navigation item component
 *
 * @CustomElement slh-nav-item
 *
 * @cssprop --slh-default-font-family - Item label font family.
 * @cssprop --slh-base-xs-font-size - Item label font size.
 * @cssprop --slh-base-xxs-line-height - Item label line height.
 * @cssprop --slh-color-neutral-shade-60 - Item label text color.
 * @cssprop --slh-color-neutral-shade-20 - Item loading background color.
 * @cssprop --slh-color-neutral-shade-10 - Item hover background color. Item focus-visible background color.
 * @cssprop --slh-color-primary - Active item side border color.
 * @cssprop --slh-color-neutral - Item label focus text color. Item lable hover font color.
 * @cssprop --slh-color-outline - Item focus-visible outline color.
 * @cssprop --slh-base-bold-font-weight - Item font weight.
 *
 * ** slots
 * @slot default - Navigation item text content (label). Required.
 * @slot icon - Navigation item visual content (icon). Optional. Not rendered for `subitem` item type.
 */
@customElement("slh-nav-item")
export default class SlhNavigationItem extends SlhBaseNavigationItem(
  LitElement,
) {}
